import { useIntl } from 'react-intl';

import CoverageFrequencyChart from '@/components/doohReport/CoverageFrequencyChart/CoverageFrequencyChart';
import SectionHeader from '@/components/doohReport/common/SectionHeader/SectionHeader';
import MetricDetailCards from '@/components/doohReport/MetricDetailCards/MetricDetailCards';

import type {
  DoohReportAudience,
  DoohReportDailyCumulative,
  DoohReportEvent,
  DoohReportMetrics
} from 'sonata-static-storage/lib/entities/doohReport/doohReport.types';

import './reachFrequency.scss';

type Props = {
  audience: DoohReportAudience;
  dailyCumulative: DoohReportDailyCumulative[] | null;
  events: DoohReportEvent[];
  metrics: DoohReportMetrics;
  sectionNumber: string;
};

/**
 * "Reach & frequency" section of the DOOH report: the KPI cards (target universe,
 * on-target impressions, reach, frequency and coverage) over the cumulative chart.
 */
export default function ReachFrequency({ audience, dailyCumulative, events, metrics, sectionNumber }: Readonly<Props>) {
  const { formatMessage } = useIntl();

  return (
    <section className="reachFrequency">
      <SectionHeader
        description={formatMessage({
          defaultMessage: 'Impressions & cumulative metrics.',
          id: 'doohReport.coverageFrequencyChart.header.description'
        })}
        number={sectionNumber}
        title={formatMessage({
          defaultMessage: 'Reach & frequency.',
          id: 'doohReport.coverageFrequencyChart.header.title'
        })}
        tooltip={formatMessage({
          defaultMessage:
            "Daily impressions, split by weekday and weekend, alongside the campaign's cumulative reach or frequency trend. Switch metrics to see each one's trend.",
          id: 'doohReport.coverageFrequencyChart.header.tooltip'
        })}
      />
      <MetricDetailCards audience={audience} metrics={metrics} />
      {dailyCumulative && <CoverageFrequencyChart dailyTimeSeries={dailyCumulative} events={events} />}
    </section>
  );
}
